import { Link } from 'react-router-dom';

export default function ContentSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 border border-accent-200 rounded-full mb-4">
              About Superbuy Spreadsheet
            </span>

            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-2">
              What Is <span className="text-primary-500">Superbuy Spreadsheet</span>?
            </h2>

            <p className="text-foreground-700/80 text-sm md:text-base leading-relaxed mt-6">
              Superbuy Spreadsheet is a <strong>structured spreadsheet system</strong> that helps international buyers organize products, track prices, estimate shipping expenses, and manage cross-border shopping workflows. Unlike scattered notes or basic lists, this system gives you a complete dashboard view of every purchase — from initial browsing to final delivery.
            </p>

            <p className="text-foreground-700/80 text-sm md:text-base leading-relaxed mt-4">
              Whether you are a casual international shopper, a reseller sourcing products globally, or a dropshipping entrepreneur managing multiple orders, the Superbuy Spreadsheet approach transforms chaotic shopping data into actionable insights. You will know exactly what you are spending, where your orders are, and how to optimize every dollar.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/article/superbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>Read Complete Guide</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
              <Link
                to="/article/superbuy-spreadsheet-for-beginners"
                className="inline-flex items-center gap-2 px-5 py-3 bg-accent-500 text-background-50 text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>New? Start Here</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-seedling-line text-sm"></i>
                </div>
              </Link>
            </div>
          </div>

          <div className="lg:w-3/5 relative">
            <div className="flex gap-4">
              <div className="w-1/3 mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20beautifully%20structured%20leather%20satchel%20bag%20in%20warm%20chestnut%20brown%20with%20gold%20tone%20hardware%20placed%20on%20a%20smooth%20light%20limestone%20surface%20soft%20diffused%20natural%20light%20from%20above%20highlighting%20the%20leather%20texture%20and%20stitching%20details%20editorial%20luxury%20accessories%20aesthetic%20sophisticated%20clean%20composition&width=600&height=800&seq=about-img-01-v2-16&orientation=portrait"
                  alt="Superbuy Spreadsheet product photography"
                  className="w-full h-auto rounded-xl object-cover aspect-[3/4]"
                />
              </div>
              <div className="w-2/3">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20office%20desk%20setup%20with%20a%20sleek%20silver%20laptop%20displaying%20colorful%20spreadsheet%20data%20next%20to%20a%20steaming%20ceramic%20coffee%20cup%20and%20a%20small%20potted%20olive%20plant%20soft%20natural%20morning%20light%20through%20a%20window%20with%20linen%20curtains%20editorial%20productivity%20aesthetic%20clean%20organized%20workspace%20with%20warm%20beige%20and%20sage%20tones&width=900&height=700&seq=about-img-02-v2-17&orientation=landscape"
                  alt="Superbuy Spreadsheet workspace setup"
                  className="w-full h-auto rounded-xl object-cover aspect-[4/3]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}